'use strict';
/**
 * Exception that fires when trying to access or use a socket that does not
 * exist.
 */

var _classCallCheck = require("C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var ExSocketNotFound =
/**
   * @param {string} source The source of the exception.
   * @param {string} peerId The identifier of the peer that has been tried.
   * @param {string} protocolId The identifier of the protocol that failed.
   * @param {string} message A error message.
   */
function ExSocketNotFound(source, peerId, protocolId, message) {
  _classCallCheck(this, ExSocketNotFound);

  this.source = source;
  this.peer = peerId;
  this.protocolId = protocolId;
  this.message = message;
};

;
module.exports = ExSocketNotFound;